export const FINISHED_STATUSES = new Set(['finished', 'canceled', 'error', 'failed']);

const FAILED_STATUSES = new Set(['error', 'failed']);

export type PositionSearchState =
    | 'pending'
    | 'found'
    | 'empty'
    | 'canceled'
    | 'failed';